import type { CollapsibleFineprintWidgetResolved } from './types';
import { Collapsible } from '@/components/Collapsible';
import { RichText } from '@/lib/render/RichText';
import { Text } from '@/lib/render/Text';

export function CollapsibleFineprintWidgetComponent({
  resolved,
}: {
  resolved: CollapsibleFineprintWidgetResolved;
}) {
  const { title, body } = resolved;
  if (!title || !body) {
    return null;
  }
  return (
    <div className="pt-4">
      <Collapsible
        header={
          <Text field="title" className="text-primary font-semibold">
            {title}
          </Text>
        }
        className="w-full rounded-none bg-transparent px-0"
        centered
      >
        <div className="[&_a]:text-primary text-xs [&_a]:underline [&_p]:mb-0 [&_strong]:font-medium">
          <RichText nodes={body} />
        </div>
      </Collapsible>
    </div>
  );
}
